import UI from './utils/UI'

UI({
  component: '.js-localVideo',
  player: '.js-localVideo-player',
  button: '.js-localVideo-button'
}, ({ component, button, player }) => {
  button.addEventListener('click', play, false)

  function play () {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'videoStart',
        src: player.src
      })
    }
    component.classList.add('is-playing')
    player.setAttribute('controls', 'controls')
    player.play()
  }
  if (window.dataLayer) {
    player.addEventListener('ended', _ => (window.dataLayer.push({
      event: 'videoEnded',
      src: player.src
    })))
  }
})
